import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaTelegramPlane } from 'react-icons/fa';
import RouteButton from '../RouteButton';
import { JOURNALER_URL, TELEGRAM_URL, MR_JOURNALER_PATH } from '../../../constants/links';
import styles from './index.module.css';

const STORAGE_KEY = 'aem-float-ai-banner-dismissed';

const FloatAIBanner = () => {
    const [isDismissed, setIsDismissed] = useState(
        () => sessionStorage.getItem(STORAGE_KEY) === 'true',
    );


    const handleDismiss = () => {
        sessionStorage.setItem(STORAGE_KEY, 'true');
        setIsDismissed(true);
    };

    if (isDismissed) {
        return null;
    }

    return (
        <aside className={styles.banner} aria-label="AI assistant promotion">
            <div className={styles.message}>
                <span className={styles.icon} aria-hidden>⚡</span>
                <span>
                    AI Support and latest news for Crypto Accounting{' '}
                    <Link to={`${MR_JOURNALER_PATH}#ai-info-section`} className={styles.learnMore}>
                        Learn More
                    </Link>
                </span>
            </div>

            <div className={styles.actions}>
                <RouteButton href={JOURNALER_URL} variant="primary" tone="light">
                    Start on Journaler
                </RouteButton>
                <RouteButton href={TELEGRAM_URL} variant="accent" icon={<FaTelegramPlane aria-hidden />}>
                    Start on Telegram
                </RouteButton>
            </div>

            <button
                type="button"
                className={styles.closeBtn}
                onClick={handleDismiss}
                aria-label="Dismiss banner"
            >
                ×
            </button>
        </aside>
    );
};

export default FloatAIBanner;
